import Pagination from '../vc-pagination/locale/fa_IR'
import DatePicker from '../date-picker/locale/fa_IR'
import TimePicker from '../time-picker/locale/fa_IR'
import Calendar from '../calendar/locale/fa_IR'

export default {
  locale: 'fa',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'منوی فیلتر',
    filterConfirm: 'تایید',
    filterReset: 'پاک کردن',
    emptyText: 'داده‌ای موجود نیست',
    selectAll: 'انتخاب صفحه‌ی کنونی',
    selectInvert: 'معکوس کردن انتخاب‌ها در صفحه ی کنونی',
  },
  Modal: {
    okText: 'تایید',
    cancelText: 'لغو',
    justOkText: 'تایید',
  },
  Popconfirm: {
    okText: 'تایید',
    cancelText: 'لغو',
  },
  Transfer: {
    notFoundContent: 'داده‌ای موجود نیست',
    searchPlaceholder: 'جستجو',
    itemUnit: '',
    itemsUnit: '',
  },
  Select: {
    notFoundContent: 'داده‌ای موجود نیست',
  },
  Upload: {
    uploading: 'در حال آپلود...',
    removeFile: 'حذف فایل',
    uploadError: 'خطا در آپلود',
    previewFile: 'مشاهده‌ی فایل',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/fa_IR.js